// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3QOB-","buttons":"RemoveExpirationActionButtons_buttons__2lhYG"};